{
  "match_play": "Match Play",
  "match_play_format": "Match Play",
  "match_play_management": "Match Play Management",
  "play_mode": "Play Mode",
  "bracket": "Bracket",
  "league": "League",
  "ryder_cup": "Team match (Ryder Cup style)",
  "scoring_type": "Scoring Type",
  "stableford": "Stableford",
  "stroke_play": "Stroke Play",
  "result_entry": "Result Entry",
  "result_only": "Result Only",
  "hole_by_hole": "Hole by Hole",
  "seeding_method": "Seeding Method",
  "by_handicap": "By Handicap",
  "random": "Random",
  "manual": "Manual",
  "generate_bracket": "Generate Bracket",
  "bracket_generated": "Bracket Generated",
  "participants": "Players",
  "participant_a": "Player A",
  "participant_b": "Player B",
  "tee_time": "Time",
  "match": "Match",
  "club": "Club",
  "handicap": "Handicap",
  "status": "Status",
  "result": "Result",
  "winner": "Winner",
  "result_not_available": "N/A",
  "bye": "Waiting for opponent",
  "not_started": "Not Started",
  "in_progress": "In Progress",
  "completed": "Completed",
  "enter_result": "Enter Result",
  "enter_match_result": "Enter Match Result",
  "select_winner": "Select Winner",
  "result_notation": "Result Notation",
  "result_notation_help": "E.g. '3/2', '1 up', 'A/S'",
  "result_notation_custom_placeholder": "Custom notation…",
  "holes_completed": "Holes Completed",
  "match_format_short": "Match Play",
  "holes_played_short": "{{n}} holes",
  "hole_range_chip": "Holes: {{start}}–{{end}}",
  "vs_short": "vs",
  "handicap_short": "HCP",
  "result_saved": "Result Saved",
  "round_n": "Round {{n}}",
  "format_created": "Format Created",
  "format_updated": "Format Updated",
  "format_deleted": "Format deleted",
  "confirm_delete_format": "Are you sure you want to delete the match play format?",
  "no_participations": "No players",
  "no_bracket_yet": "No bracket has been created yet",
  "minimum_two_participants": "At least two players are required",
  "unnamed_participant": "Unnamed player",
  "play_mode_help": "Select the play mode for the competition",
  "scoring_type_help": "Select the scoring system",
  "result_entry_help": "Select the result entry method",
  "seeding_method_help": "Select the seeding method for players",
  "setup_instructions_title": "Instructions:",
  "setup_step_1": "Create a match play format by selecting the play mode and scoring",
  "setup_step_2": "Select players and create the bracket",
  "setup_step_3": "Enter match results as they are completed",
  "back_to_competition": "Back to competition",
  "select_series": "Select series",
  "no_series_available": "No series have been created for this competition. Please create series first on the Series tab.",
  "create_format": "Create format",
  "update_format": "Update format",
  "create_bracket": "Create bracket",
  "recreate_bracket": "Recreate bracket",
  "bracket_created": "Bracket created",
  "no_bracket_created": "No bracket has been created yet",
  "click_create_to_start": "Create a bracket by selecting players and a play mode.",
  "series_label": "Series",
  "bracket_header": "Bracket · {{seriesName}}",
  "participants_ready": "{{count}} participants",
  "empty_state_help": "Create a bracket by selecting a play mode and players. You can edit the settings later.",
  "panel": {
    "settings_step": "1 — Settings",
    "players_step": "2 — Players",
    "selected_suffix": "selected"
  },
  "delete_format": "Delete format",
  "recreate_warning_title": "Warning: bracket will be recreated",
  "recreate_warning_message": "The current bracket and all results will be deleted. This action cannot be undone.",
  "edit_result": "Edit",
  "edit_match_result": "Edit match result",
  "clear_result": "Clear result",
  "result_cleared": "Result cleared",
  "cannot_change_winner_next_round_started": "The winner cannot be changed because the next round's match has already started",
  "round_0_qualifying": "Qualifying round",
  "all_rounds": "All rounds",
  "delete_bracket": "Delete bracket",
  "publish_bracket": "Publish bracket",
  "hide_bracket": "Hide bracket",
  "bracket_not_published": "The bracket has not been published.",
  "publish_bracket_link": "Publish.",
  "bracket_published": "Bracket published",
  "bracket_unpublished": "Bracket hidden",
  "publish_toggle_failed": "Failed to toggle publish status",
  "edit_match": "Edit match",
  "match_updated": "Match updated",
  "match_update_failed": "Match update failed",
  "add_participant": "Add player",
  "select_participant": "Select player",
  "cannot_edit_participants_bracket_started": "Players cannot be edited because the bracket matches have already started",
  "confirm_delete_bracket": "Are you sure you want to delete the bracket?",
  "bracket_deleted": "Bracket deleted",
  "bye_match_info": "Player is waiting for the next opponent",
  "unseated_players": "Players outside the bracket",
  "all_players_seated": "All players have been placed in the bracket",
  "empty_slot": "Empty slot",
  "waiting_for_opponent": "Waiting for opponent",
  "participant_removed": "Player removed",
  "participant_remove_failed": "Removing player failed",
  "participant_added": "Player added",
  "participant_add_failed": "Adding player failed",
  "participant_moved": "Player moved",
  "participant_move_failed": "Moving player failed",
  "participants_swapped": "Players swapped",
  "cannot_remove_last_participant_from_parent_match": "You cannot remove the last player from a match that feeds into the next round. Replace the player with another one first.",
  "slot_a_waiting_for_winner_info": "Slot A is waiting for the winner from the previous round. You can only edit slot B.",
  "slot_b_waiting_for_winner_info": "Slot B is waiting for the winner from the previous round. You can only edit slot A.",
  "show_bracket": "Full bracket",
  "show_full_bracket": "Show full bracket",
  "bracket_tree": "Match bracket",
  "bracket_round_number_qualifier": "Q",
  "finals": "Final",
  "semi_finals": "Semi-finals",
  "quarter_finals": "Quarter-finals",
  "tee": "Tee",
  "tabs": {
    "format": "Format",
    "bracket": "Bracket",
    "match_configurations": "Match configurations"
  },
  "match_configs": {
    "title": "Match configurations",
    "add": "Add configuration",
    "edit": "Edit configuration",
    "edit_title": "Edit configuration",
    "delete": "Delete configuration",
    "delete_blocked": "Configuration cannot be deleted because it is in use",
    "deleted": "Configuration deleted",
    "duplicated": "Configuration duplicated",
    "duplicate": "Duplicate",
    "duplicate_default_name_suffix": " (copy)",
    "show_usages": "Show usages",
    "empty": "No configurations",
    "scratch_label": "No course selection (scratch only)",
    "no_default": "No default",
    "create_new": "+ Create new configuration...",
    "holes_suffix": " holes",
    "override_indicator_tooltip": "Match has its own configuration",
    "confirm_edit_count": "Used in {{matchCount}} matches ({{finalisedCount}} finalised) and as default for {{roundCount}} rounds. Continue?",
    "usage_summary": "Used in {{matchCount}} matches ({{finalisedCount}} finalised) and as default for {{roundCount}} rounds.",
    "fields": {
      "name": "Name",
      "scorecard": "Scorecard",
      "mens_tee": "Men's tee set",
      "womens_tee": "Women's tee set",
      "start_hole": "Start hole",
      "end_hole": "End hole",
      "handicap_factor": "Handicap factor",
      "men_max_handicap": "Men's max. handicap",
      "women_max_handicap": "Women's max. handicap",
      "team_handicap_percentages": "Team handicap percentages (CSV)",
      "holes_range": "Holes",
      "limit_team_handicap_to_min_slope": "Limit team handicap to minimum individual handicap"
    },
    "help": {
      "team_handicap_percentages": "0.5,0.5 – Foursome\n0.6,0.4 – Greensome\n0.35,0.15 – 2-player Scramble\n0.25,0.20,0.15,0.10 – 4-player Scramble"
    },
    "validation": {
      "name_required": "Name is required",
      "end_hole": "End hole must be greater than or equal to start hole"
    }
  },
  "round_defaults": {
    "edit_title": "Settings - {{round}}",
    "deadline_label": "Deadline",
    "deadline_chip": "Deadline: {{date}}",
    "fixed_date_label": "Fixed date",
    "fixed_date_chip": "{{date}}"
  },
  "match_edit": {
    "config_label": "Configuration",
    "use_round_default_named": "Use round default — {{name}}",
    "use_round_default_no_config": "Use round default (no configuration)"
  },
  "tvBoard": {
    "noMatches": "No matches",
    "player": "Player",
    "result": "Score",
    "thru": "Thru"
  },
  "public": {
    "notYetPublished": "The bracket has not been published yet",
    "seriesSelectorLabel": "Series"
  },
  "maximum_score": "Maximum score",
  "match_config_details": {
    "title": "Match configuration",
    "scratch": "No configuration set — match is played as scratch with no course selection.",
    "scratch_label": "Scratch",
    "course": "Course",
    "mens_tee": "Men's tee",
    "womens_tee": "Women's tee",
    "hole_range": "Holes",
    "handicap_factor": "Handicap factor",
    "men_max_handicap": "Men's max. handicap",
    "women_max_handicap": "Women's max. handicap",
    "team_handicap_percentages": "Team handicap (CSV)",
    "limit_team_handicap_to_min_slope": "Team handicap upper limit",
    "enabled": "Enabled"
  },
  "bracket_properties": {
    "title": "Bracket properties",
    "game_mode": "Game mode",
    "scoring_format": "Scoring format",
    "draw_decision": "Tie-break rule",
    "handicap": "Handicap",
    "handicap_scratch": "Scratch",
    "handicap_with_factor": "With handicap ({{percent}} %)",
    "handicap_varies": "Varies — see match configurations"
  },
  "tieBreakMode": {
    "label": "Tie-break rule",
    "EXTRA_HOLES": "Extra holes",
    "MATHEMATICAL": "Mathematical (9/6/3/1)",
    "HANDICAP_LOWER": "Lower handicap",
    "PLAYING_HANDICAP_LOWER": "Lower playing handicap"
  },
  "scoring": {
    "title": "Enter Round Scores",
    "handicapBadge": "(HCP: {{value}})",
    "strokesReceivedThisHole_one": "Handicap: {{count}} stroke",
    "strokesReceivedThisHole_other": "Handicap: {{count}} strokes",
    "matchState": "Status",
    "allSquare": "A/S",
    "up": "UP",
    "down": "DOWN",
    "holesRemaining": "holes remaining",
    "matchComplete": "Match complete",
    "matchCompleteBadge": "WINS THE MATCH",
    "winner": "Winner",
    "hole": "Hole",
    "strokes": "Strokes",
    "pickedUp": "Picked up",
    "conceded": "Conceded",
    "won": "Won",
    "lost": "Lost",
    "halved": "Halved",
    "thru": "thru",
    "enterScore": "Score per hole",
    "saveScore": "Save",
    "front9": "Holes 1-9",
    "back9": "Holes 10-18",
    "endGame": "End match",
    "matchSummary": "Match summary",
    "confirmResult": "Confirm result",
    "resetScores": "Clear scores",
    "resetShort": "Clear",
    "resetScoresConfirm": "Are you sure you want to clear all match scores? This action cannot be undone.",
    "leadsBy": {
      "matchplay": "{{name}} leads by {{margin}} holes",
      "strokes": "{{name}} leads by {{margin}} strokes",
      "points": "{{name}} leads by {{margin}} points"
    },
    "tied": {
      "matchplay": "All square",
      "strokes": "Tied — {{total}}",
      "points": "Tied — {{total}} pts"
    },
    "level": "All square",
    "missingScore": "Score missing",
    "playoff": "playoff",
    "winsMatchBy": {
      "strokes": "Wins the match by {{margin}} stroke(s)",
      "points": "Wins the match by {{margin}} point(s)"
    },
    "winsMatch": "wins the match",
    "scorecardRequired": "Scorecard missing — define a scorecard for score calculation"
  },
  "hybrid_handicap_random_r0": "Hybrid (handicap + random qualifier)",
  "manual_seeding_hint": "You can override the automatic seeding by assigning your preferred seed number to a player",
  "manual_seed_aria": "Manual seed",
  "duplicate_seeds_error": "Multiple players have been assigned the same seed number: {{seeds}}. Please fix before generating the bracket.",
  "column_player": "Player",
  "column_seed": "Seed",
  "registration_open_warning": "Note! Registration is still open.",
  "qualifier_as_round1_label": "Do not show the first round as a qualifier round",
  "qualifier_as_round1_help": "When selected, a possible first partial round is \"Round 1\".",
  "reroute": {
    "feedsInto": "Winner → Match {{match}}",
    "winner_chip": "Winner",
    "success": "Qualifying match routing updated",
    "failed": "Qualifying match routing failed"
  },
  "bronze_match": "Bronze match",
  "play_bronze_match_label": "Play bronze match",
  "play_bronze_match_help": "Players who lost in the semifinals play the bronze match for third place.",
  "bronze_requires_two_semifinals": "Bronze match requires two semifinals",
  "ryderCup": {
    "title": "Team Match",
    "management_title": "Team Match Management",
    "create": "Create Team Match",
    "players_assigned_next": "Players are not selected here — they will be assigned to teams in the next step in the team match management.",
    "tab_teams": "Teams",
    "tab_sessions": "Sessions",
    "tab_scoreboard": "Scores",
    "team_name": "Team name",
    "team_colour": "Team colour",
    "no_members": "No players",
    "unassigned": "No team",
    "move_to_team_right": "{{team}} →",
    "move_to_team_left": "← {{team}}",
    "unequal_team_sizes_warning": "Team sizes differ ({{a}} vs {{b}} players)",
    "session": "Session",
    "session_default": "Session {{number}}",
    "add_session": "Create session",
    "session_name": "Name",
    "delete_session": "Delete session",
    "delete_session_confirm": "Are you sure you want to delete this session and all its matches?",
    "add_match": "Add match",
    "select_player": "Select player",
    "already_in_session": "Already in a match",
    "delete_match": "Delete match",
    "delete_match_confirm": "Are you sure you want to delete this match?",
    "delete_result": "Delete result",
    "delete_result_confirm": "Are you sure you want to delete the result of this match? The match will be reset to unplayed.",
    "error_same_team": "Both players are on the same team",
    "error_duplicate_in_session": "Player is already in this session",
    "no_sessions_yet": "No sessions. Create a session first.",
    "no_matches_in_session": "No matches in this session.",
    "finalize_as": "Finish as A/S (halved)",
    "finalize_as_confirm": "Are you sure you want to finish the match as halved (A/S)?",
    "finalize_as_header": "Finish match A/S",
    "enter_result": "Enter result",
    "edit_result": "Edit result",
    "reopen_match": "Reopen match",
    "reopen_match_confirm": "This match has already been completed. Editing the result will reopen the match and remove the current result (hole-by-hole scores will be retained) until you confirm it again. The team's point will be removed from the scoreboard in the meantime. Continue?",
    "reopen_match_confirm_action": "Reopen",
    "score": "Score",
    "confirm_finish": "Are you sure you want to finish the match? The result will be calculated from the entered scores (halved as A/S in case of a tie).",
    "team_wins": "{{team}} wins",
    "halved_as": "Halved (A/S)",
    "result_notation": "Result notation",
    "result_notation_placeholder": "e.g. 3&2, 1 up",
    "edit_schedule": "Edit schedule",
    "start_date": "Date",
    "start_time": "Start time",
    "start_tee": "Starting hole",
    "tee_n": "Hole {{n}}",
    "scoreboard": "Scoreboard",
    "session_breakdown": "Points by session",
    "team": "Team",
    "actual": "Points",
    "projected": "Projected",
    "projected_short": "Proj.",
    "tie": "Tie",
    "wins": "wins",
    "scoreboard_not_available": "Team match scoreboard is not available",
    "as_short": "A/S",
    "up_short": "UP",
    "final_short": "Final",
    "halved_short": "Halved",
    "thru_short": "Thru",
    "time_short": "Time",
    "session_settings": "Session settings",
    "publish": "Publish matches",
    "unpublish": "Hide matches",
    "not_published": "Results have not been published yet.",
    "publish_link": "Publish.",
    "published": "Matches published",
    "unpublished": "Matches hidden",
    "delete": "Delete team match",
    "confirm_delete_title": "Delete team match?",
    "confirm_delete_body": "This will permanently delete the teams, sessions and matches. This action cannot be undone.",
    "deleted": "Team match deleted",
    "props": {
      "game_mode": "Team match",
      "scoring": "Match play"
    }
  }
}
